<template>
  <div class="container-card" @click="gotoProduct(insideItem.id)">
    <div class="card">
      <div class="imgBx">
        <img :src="insideItem.imageUrl[0]" alt="圖片" />
        <h2>{{ insideItem.title }}</h2>
      </div>
      <div class="content d-flex flex-column justify-content-between">
        <div class="d-flex justify-content-center">
          <p>售價:{{ $money(insideItem.origin_price) }}</p>
        </div>
        <div class="d-flex justify-content-between">
          <button>
            詳細頁
          </button>
          <button @click.stop="addToCartHandler(insideItem.id)">
            加入購物車
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiFrontCart from '@/assets/js/api/front/apiFrontCart';
import { mapActions } from 'vuex';
export default {
  props: {
    insideItem: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    ...mapActions(['setCartLength']),
    gotoProduct(itemId) {
      this.$router.push({ name: 'product', params: { id: itemId } });
    },
    addToCartHandler(id) {
      let vm = this;
      apiFrontCart
        .post('', {
          product: id,
          quantity: 1,
        })
        .then(res => {
          if (res.status == 200) {
            this.$fire({
              title: `新增成功`,
              type: 'success',
              timer: 3000,
            });
            vm.setCartLength();
          }
        })
        .catch(() => {
          this.$fire({
            title: `已在購物車中`,
            type: 'error',
            timer: 3000,
          });
        });
    },
  },
};
</script>
